var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"error-code"},[_c('svg-icon',{attrs:{"icon-class":"404"}})],1),_c('div',{staticClass:"error-message"},[_vm._v("抱歉，您访问的页面不存在")]),_c('router-link',{staticClass:"back-home",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }